<template>
    <div :class="computedCss" v-if="computedPageTotal > 0">
        
        <template v-if="computedNowPage > 2">
            <a href="javascript:" @click="onPageClicked(computedNowPage - 1)" class="prev"></a>
            <a href="javascript:" @click="onPageClicked(1)">1</a>
            <span>...</span>
        </template>
        
        <template v-for="index in computedPageTotal">
            <template v-if="index < computedNowPage + 2 && index > computedNowPage - 2">
                <a :key="'page'+index" v-if="index !== computedNowPage" href="javascript:" @click="onPageClicked(index)">{{index}}</a>
                <a :key="'nowPage'+index" v-if="index === computedNowPage" class="now">{{index}}</a>
            </template>
        </template>
        
        <template v-if="computedNowPage !== computedPageTotal && computedNowPage !== computedPageTotal - 1">
            <span>...</span>
            <a href="javascript:" @click="onPageClicked(computedPageTotal)">{{computedPageTotal}}</a>
            <a href="javascript:" @click="onPageClicked(computedNowPage + 1)" class="next"></a>
        </template>
    </div>
</template>

<script>
    import _ from "lodash";

    export default {
        name: "Pagination",
        props: {
            value: {
                type: Object | undefined,
                required: true,
            },
            cssClass: {
                type: String,
                default: 'pagenumber',
            },
            paginationCss: {
                type: String,
                default: '',
            },
            onPage: {
                type: Function,
                default: null,
            },
            numOfDots: {
                type: Number,
                default: 5,
            }
        },
        data() {
            return {
                
            };
        },
        mounted() {
            
        },
        methods: {
            /**
             * 點擊按鈕
             * 
             * @param pageNum
             */
            onPageClicked(pageNum) {
                let updated = _.set(this.value, 'page', pageNum);
                this.$emit('input', updated);
                
                if (this.onPage != null) {
                    this.onPage(pageNum)        
                } // end of if
            }
        },
        computed: {
            computedPageTotal() {
                return _.get(this.value, 'pageTotal', 0) || 0;
            }, 
            computedNowPage() {
                return _.get(this.value, 'page', 1) || 1;
            },
            computedCss() {
                return `${this.cssClass} ${this.paginationCss ?? ''}`;
            }
        },
    };
</script>
